module.exports = __webpack_public_path__ + "assets/login_logo.0f480f6e.svg";